/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import axios from 'axios';
import { clearAuthToken, getAuthToken } from '../../utils/auth';
import { GetTokenParams, SsoTokenResponse } from './auth.models';

const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BA_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const getAuthHeader = () => {
  const authToken = getAuthToken();
  if (authToken) {
    return { Authorization: `Bearer ${authToken.token}` };
  }
};

export const getTokenValidation = async (
  token: GetTokenParams['token'],
  codeVerifier: GetTokenParams['codeVerifier'],
): Promise<SsoTokenResponse> => {
  const data = JSON.stringify({
    code: token,
    grant_type: 'authorization_code',
    client_id: process.env.NEXT_PUBLIC_BA_CLIENT_ID,
    redirect_uri: process.env.NEXT_PUBLIC_BA_REDIRECT,
    code_verifier: codeVerifier,
  });

  const response = await api.post<SsoTokenResponse>('/sso/token', data);
  return response.data;
};

export const setTokenRevocation = async (): Promise<void> => {
  try {
    await api.post<boolean>(
      '/sso/token/revoke',
      {},
      {
        headers: getAuthHeader(),
      },
    );
    clearAuthToken();
  } catch (error) {
    if (axios.isAxiosError(error)) {
      clearAuthToken();
    }
  }
};
